import React from 'react';

//constants
import { urlEspecial, resumeItemsStart } from '../../Constants';

//types
import { DataByDistrict } from '../../types/types';

//components
import CandidateHeadingData from './CandidateHeadingData';

type ComparingContentProps = {
    data: DataByDistrict[];
    slugParty1: string;
    slugParty2: string;
}

const ComparingContent = ({ data, slugParty1, slugParty2 }: ComparingContentProps) => {

    const party1CandidateProposals: DataByDistrict = data[parseInt(slugParty1)];
    const party2CandidateProposals: DataByDistrict = data[parseInt(slugParty2)];

    const numberOfItems: number = (Object.keys(party1CandidateProposals)).length

    const resumesTitles = (Object.keys(party1CandidateProposals)).slice(resumeItemsStart, numberOfItems);    
    const party1CandidateResume = (Object.values(party1CandidateProposals)).slice(resumeItemsStart, numberOfItems);    
    const party2CandidateResume = (Object.values(party2CandidateProposals)).slice(resumeItemsStart, numberOfItems);    
    const candidatesResumes = [party1CandidateResume, party2CandidateResume];

    return (
        <section className="position-relative my-1 my-md-2 px-2 px-md-3">
            <section className="position-fixed top-0 start-50 translate-middle-x bg-white row w-100 mx-auto px-2 cont-layout cont-cantidates">
                <CandidateHeadingData 
                    partyCandidateProposals={party1CandidateProposals}
                />        
                <CandidateHeadingData 
                    partyCandidateProposals={party2CandidateProposals}
                /> 
            </section>
            <section className="position-relative mb-4 cont-resume-proposals">
                <section className="my-4 my-md-5">
                {resumesTitles.map((resumeTitle, i) =>  
                    <section key={i} className="row mb-4 px-2 px-md-3 text-center cont-text-proposal">
                        <article className="col-12">
                            <h5 className="my-2 text-grey-resume-title proposal-title">{resumeTitle.replaceAll('_', ' ')}</h5>
                        </article>
                        {candidatesResumes.map((candidateResume, j) => 
                            <article key={j} className={`col-6 px-3 py-4 bg-text-proposal ${(j === 0) ? 'border-proposal': ''}`}>
                                <p className="mb-0 text-proposal">{candidateResume[i]}</p>
                            </article>
                        )}
                    </section>
                )}
                </section>
                <article className="my-3 my-md-5 pt-3 pt-md-4 text-center">
                    <a className="btn btn-dark rounded-0 px-4 px-md-5 py-2 btn-compare" href={urlEspecial}>
                        Volver                            
                    </a>
                </article>
            </section>
        </section>
    )
}

export default ComparingContent;